import axios from "axios";

const apiNotifications = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_NOTIFICATIONS_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8087"
});

export default apiNotifications;
